import React from 'react';
import './UserLogin.scss';
import { Redirect, NavLink } from "react-router-dom";
import request from '../../utils/agent';

export default class UserLogin extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            isAuthenticated: false,
            myToken: '',
            role: '',
            savingNewPassword: false,
            errorMessage: '',
        };

        this.role = null;
        this.isAuthenticated = null;
    }

    getUserData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    resolve(resp.body.user);
                });

        });
    };

    submitLogin = async () => {
        var [err, auth] = await this.props.authHandler.getUserAuth(this.refs.email.value, this.refs.password.value);

        if(err || auth.statusCode !== 200 || auth.body.error) {
            this.setState({error: true});
            return;
        } 
        this.props.authHandler.setAuth(auth.body.token);

        var [err, role] = await this.props.authHandler.getUserRole();
        if(err) {
            console.log("ERROR: Getting users role");
            console.log(err);
        }

        let user;
        try {
            user = await this.getUserData();
        } catch(e) {
            console.log("ERROR: this.getUserData");
            console.log(e);
            return;
        }

        this.isAuthenticated = this.props.authHandler.isAuthenticated;
        this.role = role.role.name;
        this.userId = user.id;

        //console.log(user);

        // The common factor is if linked = false
        if(!auth.body.linked) {
            this.openResetPasswordModal();
            return;
        }

        // This should be the check to send them to the agreement page

        this.setState({
            isAuthenticated: this.props.authHandler.isAuthenticated,
            role: role.role.name
        });
    };

    openResetPasswordModal = () => {
        document.querySelector('body').classList.add('modal-open');
        this.refs.resetPasswordModal.classList.add('in');
    }

    saveNewPassword = () => {
        let pass1 = this.refs.new_password.value;
        let pass2 = this.refs.repeat_new_password.value;

        if(pass1 !== pass2) {
            this.setState({
                errorMessage: "Passwords do not match"
            });
            return;
        }

        if(pass1.length < 8) {
            this.setState({
                errorMessage: "Passwords must be a minimum of 8 characters"
            });
            return;
        }
        request.post('/api/user/user-reset-pass')
            .send({
                old_password: this.refs.password.value,
                password: pass1
            })
            .then(resp => {
                this.setState({
                    isAuthenticated: this.isAuthenticated,
                    role: this.role
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({
                    errorMessage: "An error occurred, please refresh the page and try again"
                });
            })
    }

    resetPasswordModal = () => {
        return (
            <div id="resetPasswordModal" ref="resetPasswordModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title"><span></span>Please reset your password</h4>
                        </div>
                        <div className="modal-body">
                            <p>To sync your NOON Pro portal and app accounts, please reset your password. Then you’ll be able to use the same login for both the website and the app.</p>
                            <div className="form-group col-xs-12">
                                <label htmlFor="company_name">New Password</label>
                                <input type="password" 
                                    id="new_password" 
                                    name="new_password" 
                                    ref="new_password"
                                    className="form-control"/>
                            </div>
                            <div className="form-group col-xs-12">
                                <label htmlFor="company_name">Repeat New Password</label>
                                <input type="password" 
                                    id="repeat_new_password" 
                                    name="repeat_new_password" 
                                    ref="repeat_new_password"
                                    className="form-control"/>
                            </div>
                            {this.state.errorMessage && 
                                <div className="alert alert-danger">
                                    { this.state.errorMessage }
                                </div>
                            }
                            <button onClick={this.saveNewPassword} 
                                type="button" 
                                id="saveNewPassword" 
                                className="btn btn-default btn-primary" 
                                name="saveNewPassword" 
                                disabled={this.state.savingNewPassword}>
                                    Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    handleEnterKey = (e) => {
        if(e.key === 'Enter') {
            this.submitLogin();
        }
    }


    render() {

        //console.log('role', this.state.role);
        //console.log('token', this.state.myToken);
        let msg = null;
        try {
            msg = location.search && decodeURIComponent(location.search.split('=')[1]);
            if(msg === 'undefined') msg = null;
        } catch(e) {}

        if(this.state.isAuthenticated) {
            if(this.state.role === 'owner' || this.state.role === 'admin' || this.state.role === 'pOwner') {
                return <Redirect to='/admin' />;
            }
            return <Redirect to='/user' />
        }


        return (
        <div className="login-page">
            <section className="site-centered">
                <div className="row justify-content-md-center">
                    <div id="login-form" className="col-sm-6 col-xs-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h1 className="panel-title">Login</h1>
                            </div>
                            <div className="panel-body">

                                {msg && 
                                    <div className="alert alert-success">
                                        {msg}
                                    </div>
                                }

                                {this.state.error && <div className="alert alert-danger">
                                    <p>Authentication failed</p>
                                </div>}
                                
                                <div className="form-group">
                                    <input ref="email" type="email" name="email" placeholder="Email" className="form-control"/>
                                </div>
                                <div className="form-group">
                                    <input ref="password" type="password" name="password" placeholder="Password" onKeyUp={this.handleEnterKey} className="form-control" />
                                </div>
                                <button type="submit" onClick={this.submitLogin} className="btn btn-default btn-primary login-b">Log In</button>
                                <NavLink className="btn btn-default btn-primary btn-gray" to="/password/reset">Forgot Password</NavLink>
                                    

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {this.resetPasswordModal()}
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserLogin/index.js